import { createApi } from '@reduxjs/toolkit/query/react'
import { customFetchBaseQuery } from '../app/baseQuery'
import { GetConfigResponse } from '../../types/patient-api-gateway/api/patient/widget/v1/widget_gateway_service'

export const appConfigApi = createApi({
  reducerPath: 'appConfigApi',
  baseQuery: customFetchBaseQuery,
  tagTypes: ['Config'],
  endpoints: (builder) => ({
    getPatientWidget: builder.query<GetConfigResponse, void>({
      query: () => ({
        url: '/api.patient.widget.v1.WidgetGatewayService/GetConfig',
        method: 'POST',
      }),
      extraOptions: {
        maxRetries: 3,
      },
      providesTags: ['Config'],
      keepUnusedDataFor: 300,
    }),
  }),
})

export const { useGetPatientWidgetQuery } = appConfigApi
